import { render, staticRenderFns } from "./DashboardAnalyticsBookings.vue?vue&type=template&id=5c185c06"
import script from "./DashboardAnalyticsBookings.vue?vue&type=script&lang=js"
export * from "./DashboardAnalyticsBookings.vue?vue&type=script&lang=js"
import style0 from "./DashboardAnalyticsBookings.vue?vue&type=style&index=0&id=5c185c06&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports